import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '../../model/address.model';
import { CartItem } from '@app/model/cart.model';

@Pipe({
    name: 'requestedItemFilter'
})
export class RequestedItemFilterPipe implements PipeTransform {

    transform(items: CartItem[]) {
        return items.filter(item => item.userAdded || item.item.price.amount > 0);
    }
}
